import { useState } from "react";

function WorkingWeek({
    workerWeek,
    onWeekChange = () => { }
}) {

    let isDevMode = process.env.REACT_APP_IS_DEV == "true"

    let cleanWeek = [
        {
            day: "LUN",
            slots: [],
        },
        {
            day: "MAR",
            slots: []
        },
        {
            day: "MER",
            slots: []
        },
        {
            day: "GIO",
            slots: []
        },
        {
            day: "VEN",
            slots: []
        },
        {
            day: "SAB",
            slots: []
        },
        {
            day: "DOM",
            slots: []
        },

    ]

    const [workingWeek, setWorkingWeek] = useState(workerWeek != null && workerWeek.length > 0 ? JSON.parse(JSON.stringify(workerWeek)) : cleanWeek)

    let copy = workingWeek.slice()

    const handleSlotsEdit = (day, slotsEdit) => {
        console.log("Received new slots for " + day)

        let dayIndex = copy.findIndex((item) => item.day == day)
        copy[dayIndex].slots = slotsEdit
        setWorkingWeek(copy)
        onWeekChange(copy)
    }

    function toMins(time) {
        var parts = time.split(':');
        return (+parts[0] * 60 + +parts[1]) || 0;
    }

    function getDailyHours(slots) {
        return slots.map(slot => (toMins(slot.end) - toMins(slot.start)) / 60).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
    }


    return (
        <>

            <table className="table table-dark table-hover  table-bordered border-secondary">

                <tbody>
                    {
                        workingWeek.map(weekDay => {
                            return <tr scope="row" key={weekDay.day} >
                                <th className={`col-1 ${weekDay.slots.length == 0 && "opacity-25"}`}>{weekDay.day} <br /><small className="text-muted">{getDailyHours(weekDay.slots)} ore</small></th>
                                <td className="col-2"><WorkTime slots={weekDay.slots} onValueChanged={(newSlots) => { handleSlotsEdit(weekDay.day, newSlots) }} /></td>

                            </tr>

                        })
                    }
                </tbody>
            </table>
            {/* {
                isDevMode &&
                <>
                    {JSON.stringify(workingWeek.map(weekDay => {

                        return {
                            day: weekDay.day,
                            slots: weekDay.slots.map(slot => {
                                return {
                                    start: slot.start,
                                    end: slot.end,
                                    interval: (toMins(slot.end) - toMins(slot.start)) / 60,
                                }
                            }),
                            duration: weekDay.slots.map(slot => (toMins(slot.end) - toMins(slot.start)) / 60).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                        }

                    }))}

                    <br />
                    {
                        workingWeek.map(weekDay =>
                            weekDay.slots.map(slot => (toMins(slot.end) - toMins(slot.start)) / 60)
                                .reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                        ).reduce((accumulator, currentValue) => accumulator + currentValue, 0)
                    }
                </>
            } */}
        </>
    )
}

export default WorkingWeek

function WorkTime({
    slots = [],
    onValueChanged = () => { }
}) {

    console.log("#SLOTS: " + JSON.stringify(slots))

    let minWorkTimeSlots = 0
    let maxWorkTimeSlots = 3

    var copy = slots.slice()

    const handleStartTimeChange = (index, e) => {
        copy[index].start = e.target.value
        onValueChanged(copy)
    }

    const handleEndTimeChange = (index, e) => {
        copy[index].end = e.target.value
        onValueChanged(copy)
    }

    const handleSlotDelete = (index) => {
        copy.splice(index, 1)
        onValueChanged(copy)
    }

    const handleSlotAdding = () => {
        onValueChanged(copy.concat({ start: "09:00", end: "17:00" }))
    }


    return (
        <>
            {
                slots.map((slot, index) => {
                    return <div key={index}>
                        <div className="row mb-1">
                            <div className="col-2 col-sm-4">
                                <input type="time" id="time-start" name="appt1" min="00:00" max="24:00" value={slot.start} onChange={(e) => handleStartTimeChange(slots.indexOf(slot), e)} required />
                            </div>
                            <div className="col-2  col-sm-4">
                                <input type="time" id="time-end" name="appt2" min="00:00" max="24:00" value={slot.end} onChange={(e) => handleEndTimeChange(slots.indexOf(slot), e)} required />
                            </div>
                            {
                                // DELETE
                                slots.indexOf(slot) >= minWorkTimeSlots &&
                                <div className="col-2 col-sm-4">
                                    <button className="btn p-0 m-0" onClick={() => { handleSlotDelete(slots.indexOf(slot)) }}> <i className="fa-solid fa-trash-can text-danger" ></i> </button>
                                </div>
                            }
                        </div>
                        {
                            slots.indexOf(slot) < maxWorkTimeSlots - 1 &&
                            <hr />
                        }

                        {
                            // +
                            (slots.indexOf(slot) == slots.length - 1 && slots.length < maxWorkTimeSlots) &&
                            <div className="row text-start">
                                <div className="col-6">
                                    <button className="btn p-0 m-0" onClick={handleSlotAdding}><i className="fa-solid fa-circle-plus text-white"></i></button>
                                </div>
                            </div>
                        }
                    </div>
                })
            }
            {
                slots.length == 0 &&
                <div className="row text-start">
                    <div className="col-6">
                        <button className="btn p-0 m-0" onClick={handleSlotAdding}><i className="fa-solid fa-circle-plus text-white"></i></button>
                    </div>
                </div>
            }
        </>
    )

}